/* eslint-disable @typescript-eslint/naming-convention */
import { sanitize } from '@brandfolder/utilities';
import React, { FunctionComponent, ReactNode } from 'react';

import { AssetDetailsRule } from './AssetDetailsRule';

import classes from './styles/asset-details-metadata.module.scss';

interface AssetDetailsMetadataProps {
  approvedBy: string;
  awaitingApproval: string;
  collectionExpiration: string;
  expired: boolean;
  expirationDate: string;
  isWorkspace: boolean;
  publishDate: string;
  unpublished: boolean;
  updatedAndCreated: string;
}

export const AssetDetailsMetadata: FunctionComponent<AssetDetailsMetadataProps> = (props) => {
  const {
    approvedBy,
    awaitingApproval,
    collectionExpiration,
    expired,
    expirationDate,
    isWorkspace,
    publishDate,
    unpublished,
    updatedAndCreated
  } = props;

  const renderDot = (): ReactNode => (isWorkspace ? <span className={classes['asset-details-metadata__bullet']}>&middot;</span> : null);

  return (
    <div className={isWorkspace && classes['asset-details-metadata']}>
      {!!updatedAndCreated && <div dangerouslySetInnerHTML={{ __html: sanitize(updatedAndCreated) }} />}

      {!!approvedBy && renderDot()}
      {!!approvedBy && <div dangerouslySetInnerHTML={{ __html: approvedBy }} />}

      {!!awaitingApproval && renderDot()}
      {!!awaitingApproval && <div dangerouslySetInnerHTML={{ __html: awaitingApproval }} />}

      {!!collectionExpiration && renderDot()}
      {!!collectionExpiration && <div dangerouslySetInnerHTML={{ __html: collectionExpiration }} />}

      {!!publishDate && renderDot()}
      {!!publishDate && (
        <div className="s-modal-published-on">
          {`${unpublished ? bfTranslate('Will Publish on') : bfTranslate('Published on')} ${publishDate}`}
        </div>
      )}

      {!!expirationDate && renderDot()}
      {!!expirationDate && (
        <div className="s-modal-expires-on">
          {`${expired ? bfTranslate('Expired on') : bfTranslate('Expires on')} ${expirationDate}`}
        </div>
      )}

      {isWorkspace && <AssetDetailsRule />}
    </div>
  );
};
